$(document).ready(function () {
    'use strict';

    $('.js_printDirections').on('click', function () {
        printPopup($('#directionsPanel').html());
    });

});